const translations = {
    other: 'Other'
};

export default translations;
